export const defaultNavbarContent = {
  primaryCTA: "Book your visit",
  primaryCTAUrl: "/booking",
  secondaryCTA: "Contact Us",
  secondaryCTAUrl: "/contact",
  logoUrl:
    "https://assets.practicewithjoy.ai/shared/logo-example.svg",
};
